var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.part=='title')?_c('editor-content',{attrs:{"editor":_vm.editorTitle}}):(_vm.part=='description')?_c('editor-content',{attrs:{"editor":_vm.editorDescription}}):_c('editor-content',{attrs:{"editor":_vm.editorImage}})
}
var staticRenderFns = []

export { render, staticRenderFns }